import { render } from "./EditProject.vue?vue&type=template&id=028abf10"
import script from "./EditProject.vue?vue&type=script&lang=js"
export * from "./EditProject.vue?vue&type=script&lang=js"

import "./EditProject.vue?vue&type=style&index=0&id=028abf10&lang=scss"

import exportComponent from "/Users/william/Documents/beadographer3/bead3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__